<template>
  <div class="container">
    <base-table v-if="livelist.length > 0" :data="livelist" thead-classes="text-primary">
      <template slot="columns" slot-scope="{ columns }">
        <th>Ticker</th>
        <th @click="updateSort('price')">
          Last value <sort-caret :name="'price'" :current="sort.current" :status="sort.order"></sort-caret>
        </th>
        <th @click="updateSort('timestamp')">
          Last update <sort-caret :name="'timestamp'" :current="sort.current" :status="sort.order"></sort-caret>
        </th>
        <th>Actions</th>
      </template>
      <template slot-scope="{ row }">
        <td>
          {{row.na}} - {{row.sy}}<br>
          <small>{{row.id}} - {{row.isin}}</small>
        </td>
        <td>{{ row.li.last | currency({symbol: '€', fractionCount: row.pd}) }}</td>
        <td>
          {{$moment(row.li.lt*1000).format('llll')}}
        </td>
        <td></td>
      </template>
    </base-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { BaseTable } from '@/components';
import SortCaret from '../../components/Tables/SortCaret';

export default {
  components: {
    BaseTable,
    SortCaret,
  },
  data() {
    return {
      positions: [],
      sort: {
        current: 'duration',
        order: -1
      }
    };
  },
  computed: {
    ...mapGetters({
      livelist: 'instruments/livelist'
    }),
  },
  methods: {
    updateTable(){
      this.positions = this.livelist
        .sort( (a,b) => {
          if( !this.sort.current || this.sort.current === 'name') {
            return a.na.localeCompare(b.na) * this.sort.order;
          } 
          if( this.sort.current === 'price') {
            return (a.li.last - b.li.last) * this.sort.order;
          }
          if( this.sort.current === 'timestamp') {
            return (a.li.lt - b.li.lt) * this.sort.order;
          }
        })
    },
    updateSort(sortOn) {
      if( sortOn !== this.sort.current ) {
        this.sort.current = sortOn;
        this.sort.order = 1;
      } else {
        this.sort.order = this.sort.order * -1;
      }
      this.updateTable();
    },
  }
};
</script>

<style>
</style>
